/* @flow */

import { combineReducers } from 'redux';
import balcaoReducer from '../ducks/balcao';
import empresaReducer from '../ducks/empresa';
import funcionamentoReducer from '../ducks/funcionamento';
import loadingReducer from '../ducks/loading';
import atalhosReducer from '../ducks/atalhos';
import usuarioReducer from '../ducks/usuario';
import notificacoesReducer from '../ducks/notificacoes';
import intervaloDataReducer from '../ducks/intervalo-data';
import relatoriosReducer from '../ducks/relatorios';
import atendimentoReducer from '../ducks/atendimento';
import relogioReducer from '../ducks/relogio';
import loggiReducer from '../ducks/loggi';

export default combineReducers({
    balcao: balcaoReducer,
    empresa: empresaReducer,
    funcionamento: funcionamentoReducer,
    loading: loadingReducer,
    atalhos: atalhosReducer,
    usuario: usuarioReducer,
    notificacoes: notificacoesReducer,
    relatorios: relatoriosReducer,
    intervaloData: intervaloDataReducer,
    atendimento: atendimentoReducer,
    relogio: relogioReducer,
    loggi: loggiReducer,
});
